import React from 'react';

const PATTERN = '[0-9.,\\s]*';

type Props = React.InputHTMLAttributes<HTMLInputElement>;

const NumericInput = React.forwardRef<HTMLInputElement, Props>(function NumericInput(props, ref) {
  const valueProps: Pick<Props, 'defaultValue' | 'value'> = {};
  if (props.defaultValue) {
    valueProps.defaultValue = props.defaultValue;
  } else if (props.value) {
    valueProps.value = props.value;
  }

  return (
    <input
      ref={ref}
      type="text"
      pattern={props.pattern || PATTERN}
      className={props.className}
      required={props.required}
      placeholder={props.placeholder}
      disabled={props.disabled}
      name={props.name}
      {...valueProps}
      value={props.value}
      onChange={props.onChange}
      aria-label={props['aria-label']}
    />
  );
});

export default NumericInput;
